import featureFlagWorkspaceService from 'services/FeatureFlagService';

export default class FeatureFlagService {
  get() {
    return (featureFlagWorkspaceService.get());
  }

  is(featureName) {
    return (featureFlagWorkspaceService.is(featureName));
  }

  set(featureName, isSet) {
    return (featureFlagWorkspaceService.set(featureName, isSet));
  }

  subscribe(flagName, callback) {
    return featureFlagWorkspaceService.subscribe(flagName, callback);
  }

  unsubscribe(flagName) {
    return featureFlagWorkspaceService.unsubscribe(flagName);
  }

  static build(args) {
    return new FeatureFlagService(args);
  }
}
